/* eslint-disable radix */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { FAQ_TYPES } from 'pages/ApplicationUI/constant';
import { DELETE_FAQ } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import DebounceTextInput from 'components/DebounseTextInput';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import AddEditFAQ from '../AddEditFAQ';
import FAQDataList from './components/FAQDataList';

const FAQList = ({ countryType = FAQ_TYPES.INDIAN_FAQ }) => {
  const [searchString, setSearchString] = useState('');
  const [showAddEditRecord, setShowAddEditRecord] = useState({
    type: ADD_EDIT_CONSTANT.ADD,
    value: '',
    refetch: () => {},
    status: false,
  });
  const [deleteRecord, setDeleteRecord] = useState({
    status: false,
    id: '',
    refetch: () => {},
  });
  const [deleteFAQ] = useMutation(DELETE_FAQ, {
    // eslint-disable-next-line no-shadow
    onCompleted: ({ deleteFAQById }) => {
      toast.success(deleteFAQById);
      setDeleteRecord({
        status: !deleteRecord.status,
        id: '',
        refetch: () => {},
      });
      deleteRecord?.refetch();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        toast.error(message);
        return message;
      });
      setDeleteRecord({ status: !deleteRecord.status, id: '' });
    },
  });

  const toggleDeleteRecord = (id, refetch = () => {}) => {
    setDeleteRecord({ status: !deleteRecord.status, id, refetch });
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteFAQ({
        variables: { id: parseInt(deleteRecord.id) },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const handleChange = (value) => {
    setSearchString(value);
  };

  const drawerToggle = (value, type, refetch = () => {}) => {
    setShowAddEditRecord({
      type,
      value,
      refetch,
      status: !showAddEditRecord?.status,
    });
  };

  return (
    <>
      <FSBModal
        title={`${showAddEditRecord?.type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Create'}
 New FAQ`}
        open={showAddEditRecord?.status}
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        message=""
        modalClass="right-drawer"
      >
        <AddEditFAQ
          type={showAddEditRecord.type}
          value={showAddEditRecord.value}
          refetch={showAddEditRecord.refetch}
          toggleFAQForm={drawerToggle}
        />
      </FSBModal>
      <DeleteConfirmationAlert
        open={deleteRecord.status}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <DebounceTextInput
        onInputChange={handleChange}
        delay={500} // Set your desired delay in milliseconds
        value={searchString}
        placeholder="Search FAQs"
        positionRight="60px"
        positionTop="-51px"
      />

      <FAQDataList
        countryType={countryType}
        toggleDeleteRecord={toggleDeleteRecord}
        searchString={searchString}
        handleClickEdit={drawerToggle}
      />
    </>
  );
};

export default FAQList;
